import { IMAGE, IMAGES } from '../constants';
function getDisplayCountData(displayMessage, images) {
  const imagesLength = images && images.length;
  const shouldDisplayCount = !!(displayMessage && imagesLength);
  const message = `${imagesLength} ${imagesLength === 1 ? IMAGE : IMAGES}`;
  const countMessage = shouldDisplayCount ? message : '';
  return {
    shouldDisplayCount,
    countMessage
  };
}
export default getDisplayCountData;
//# sourceMappingURL=get-display-count-data.js.map